import {
  OnInit,
  EventEmitter,
  Directive,
  ElementRef,
  HostListener,
  Output,
  Renderer2,
  Input
} from '@angular/core';
import * as zxcvbn from 'zxcvbn';

import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[passwordStrength]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordStrengthDirective,
      multi: true
    }
  ]
})
export class PasswordStrengthDirective implements OnInit, Validator {
  @Input('passwordValidationOptions') passwordValidationOptions;
  @Output() passwordScore: any = new EventEmitter<number>(); //eslint-disable-line
  @Output() passwordSuggestions: any = new EventEmitter<any>(); //eslint-disable-line

  validatorFn: any; //eslint-disable-line
  // pattern for password validation. It should contain one uppercase letter, one lowercase letter, one number and one special character { !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~}
  //
  patternForUppercaseChar: RegExp = /(?=[A-Z])/; //eslint-disable-line
  patternForLowercaseChar: RegExp = /(?=[a-z])/; //eslint-disable-line
  patternForNumber: RegExp = /(?=\d)/; //eslint-disable-line
  patternForSpecialChar: RegExp = /(?=[!"#\$%&'\(\)\*+,\-\.\/:;<=>\?@\[\\\]\^_`\{|\}~])/; //eslint-disable-line

  /*
      ElementRef - direct access to DOM, Renderer2 - best practice to manipulate DOM attributes and properties
      https://medium.com/@kmathy/angular-manipulate-properly-the-dom-with-renderer-16a756508cba
  */
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {
    this.validatorFn = this.configureValidator();
  }

  ngOnInit() {
    this.passwordScore.emit(0);
  }
  @HostListener('keyup', ['$event']) //eslint-disable-line
  // Should be disabled until unit test is fixed
  //@Debounce(600)
  onKeyUp($event) {
    //eslint-disable-line
    // It was possible to get password from ngModel using input
    // But to ensure debounce method gets newest version, we need to access value of input after each keypress
    const password: string = $event.target.value;
    // Resolve password strength score using zxcvbn function
    const pswInfo = zxcvbn(password);

    this.passwordScore.emit(pswInfo.score);
    this.passwordSuggestions.emit(pswInfo.feedback.suggestions);
  }

  validate(control: UntypedFormControl) {
    //eslint-disable-line
    return this.validatorFn(control.value);
  }

  configureValidator() {
    return pwdInput => {
      //eslint-disable-line
      if (!pwdInput) {
        return null; //nothing to be validated yet
      }
      if (this.isValid(pwdInput)) {
        return { pattern: 'bad' };
      }
      const pswInfo = zxcvbn(pwdInput);
      if (!pswInfo || pswInfo.score < 0) {
        return { strength: 'bad' };
      }

      return null;
    };
  }

  isValid(text: string): boolean {
    return !(
      (this.patternForUppercaseChar.test(text) ||
        this.passwordValidationOptions.minUpperCaseChar === 0) &&
      (this.patternForLowercaseChar.test(text) ||
        this.passwordValidationOptions.minLowerCaseChar === 0) &&
      (this.patternForNumber.test(text) || this.passwordValidationOptions.minDigits === 0) &&
      (this.patternForSpecialChar.test(text) ||
        this.passwordValidationOptions?.minSpecialChar === 0)
    );
  }
}
